module.exports = __webpack_public_path__ + "static/media/studio-etc12.83948603.png";